/**
 * @file site-id.service.ts
 * @description {@link https://jira.walmart.com/browse/WDE-9442}
 * The service to provide the `site-id` value for SiteIdInterceptor to use.
 * As per {@link https://jira.walmart.com/browse/WDE-6036}, the value is a hard-coded
 * value of site-code US which is dependent on the environment (dev/prod/etc) for the time being.
 * The values can be retrieved from {@link https://identity.tenant.dev.walmart.com/v1/identity/tenants}
 * {@link https://identity.tenant.staging.walmart.com/v1/identity/tenants}
 * {@link https://identity.tenant.prod.walmart.com/v1/identity/tenants}
 */

import { Inject, Injectable, InjectionToken, Optional } from "@angular/core";

/**
 * The hard-coded value provided in main.ts for the time being
 */
export const SiteIdValue = new InjectionToken<String>('SiteIdValue');


/**
 * The service to provide the site id value to SiteIdInterceptor
 * The service is here to support possible dynamic site id value in the future.
 */
@Injectable({
    providedIn: 'root'
})
export class SiteIdService {
    private _siteId = '';
    constructor(
        @Optional() @Inject(SiteIdValue) _hardcodeValue: string
    ) {
        if(_hardcodeValue)
            this._siteId = _hardcodeValue;
     }
    get siteId() {
        return this._siteId;
    }
}
